<template>
  <div class="selected-place-info result-info" style="z-index: 100000">
    <a href="#" @click.prevent="$router.push($route.path)" class="close"></a>

    <div class="tabs">
      <div class="tab" data-tab="form">
        <form class="no-padding">
          <h4 class="biggest">{{ $t("planes.thx_payment") }}</h4>

          <div class="cols">
            <div class="price">
              <p>
                <strong>{{ $t("planes.features_select_seat") }}</strong>
              </p>
              <p>
                <em>{{ $route.query.selected }}</em>
              </p>
            </div>
          </div>
          <div class="cols">
            <div class="price">
              <p>
                <strong>{{ $t("planes.select_payment_type") }}</strong>
              </p>
              <p>
                <em>{{
                  +$route.query.ptype === 1
                    ? $t("planes.payment_by_portal")
                    : +$route.query.ptype === 2
                    ? $t("planes.payment_by_terminal")
                    : $t("planes.payment_cashe")
                }}</em>
              </p>
            </div>
          </div>
          <p class="notice">
            {{ $t("planes.success_payment_notice") }}
          </p>

          <div class="buttons">
            <input
              type="button"
              class="submit small"
              @click.prevent="$router.push($route.path)"
              value="Закрыть страницу"
            />
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "SuccessPayment",
  props: ["order", "type"],
  mounted() {
    this.$emit("updateSeat", {
      guid: this.$route.query.guid
    });
  }
};
</script>

<style scoped></style>
